import React, { useState } from 'react';
import { Users, FileText, MessageSquare, AlertCircle, Settings, BarChart3 } from 'lucide-react';
import '../assets/css/adminDashboard.css';

// Tab Components (will be created separately)
import OverviewTab from '../components/admin/OverviewTab';
import UsersTab from '../components/admin/UsersTab';
import ConversationsTab from '../components/admin/ConversationsTab';
import DocumentsTab from '../components/admin/DocumentsTab';
import FeedbackTab from '../components/admin/FeedbackTab';
import SettingsTab from '../components/admin/SettingsTab';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', icon: BarChart3, component: OverviewTab },
    { id: 'users', label: 'Users', icon: Users, component: UsersTab },
    { id: 'conversations', label: 'Conversations', icon: MessageSquare, component: ConversationsTab },
    { id: 'documents', label: 'Documents', icon: FileText, component: DocumentsTab },
    { id: 'feedback', label: 'Feedback', icon: AlertCircle, component: FeedbackTab },
    { id: 'settings', label: 'Settings', icon: Settings, component: SettingsTab },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1 className="admin-title">Admin Dashboard</h1>
        <p className="admin-subtitle">Manage users, content, and system settings</p>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={18} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="admin-content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default AdminDashboard;
